import { network } from 'services/network';

export const setComponentColumns = (params) => {
    const payload = {
        columns: JSON.stringify(params.columns),
        componentId: params.widgetId,
    };
    return network.post('api/bo/reporting/setComponentColumns', payload).then((response) => {
        return response.data;
    });
};
